/**
 * Handles all focus to anchor
 * @module maskDate to
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options.js';
import 'jquery-mask-plugin';

// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'maskDate';
export const DEFAULTS = {
  updateURL: false
};

function setFormating($el, opts) {
  if ($el.length) {
    $el.mask('00/00/0000');
  }
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function maskDate(el, options = {}, { deregister }) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setFormating($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, maskDate);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/mask-date.js